<template>
    <div class="checkboxes" :class="[showCollapse ? 'show' : null, readonly ? 'read-only' : null]" v-click-outside="hide">
        <b-form-group class="mb-0">
            <b-form-checkbox-group :id="'checkbox-group-' + name" v-model="selected" :name="name">
                <b-row class="p-1" @click="changeShowCollapse">
                    <b-col :cols="8">
                        <label v-if="required" class="selected-labels">
                            <span style="color:red">*</span>                            
                            <strong>{{label}}: </strong>
                            <span v-for="(item, index) in selected" v-bind:key="index" v-html="index === 0 ? options.formatOption(item) : ', ' + options.formatOption(item)"></span>
                        </label>
                        <label class="selected-labels" v-else>
                            <strong>{{label}}: </strong>
                            <span v-for="(item, index) in selected" v-bind:key="index" v-html="index === 0 ? options.formatOption(item) : ', ' + options.formatOption(item)"></span>
                        </label>
                    </b-col>

                    <b-col :cols="4" class="text-right">
                        <b-button-group>
                            <b-button v-if="options.enableSelectAll && (selected == undefined || selected.length !== optionList.length)&& !this.readonly"
                                    @click.stop="checkAll"
                                    class=" border-0"
                                    variant="info"
                                    size="sm"
                                    >
                                <i class="far fa-check-square"></i>
                            </b-button>

                            <b-button v-if="options.enableSelectAll &&  (selected == undefined || selected.length > 0)&& !this.readonly "
                                    @click.stop="uncheckAll"
                                    class=" border-0"
                                    variant="warning"
                                    size="sm"
                                    >
                                <i class="far fa-square"></i>
                            </b-button>

                            <b-button v-if="!this.readonly"
                                    :class="showCollapse ? 'collapsed' : null"
                                    :aria-expanded="showCollapse ? 'true' : 'false'"
                                    :aria-controls="'collapse-' + name"
                                    class="collapse-toggle custom-color"
                                    size="sm"
                                    >
                                <i class="fas fa-chevron-down"></i>
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>

                <b-collapse :id="'collapse-' + name" class="checkbox-list p-1" v-model="showCollapse">
                    <input class="select-search mt-2" type="text" v-model="queryText" ref="search" @keydown.esc="hide()"
                           :placeholder="options.locale && options.locale['searchPlaceholder'] ? options.locale['searchPlaceholder'] : ''">
                    <div v-if="loading" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="text-center" v-if="filteredOptionList.length < 1 && !loading">
                        {{options.locale && options.locale['noResults'] ? options.locale['noResults'] : ''}}
                    </div>
                    <div class="option-wrapper my-2">
                        <ul v-if="filteredOptionList.length > 0 && !loading">
                            <li v-for="(item, index) in filteredOptionList" v-bind:key="index">
                                <b-form-checkbox :value="item">{{options.formatOption(item)}}</b-form-checkbox>
                            </li>
                        </ul>
                    </div>
                </b-collapse>

            </b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'
    export default {
        name: "Checkboxes",
        components: {},
        directives: {
            ClickOutside
        },
        props: {
            value: {type: Array},
            label: {type: String},
            name: {type: String},
            options: { type: Object },
            readonly: {type: Boolean, default: false},
            externalOptionList: {type: Array},
            additionalApiCallbackParams: {type: Object},
            required: {type: Boolean, default: false},
        },
        data() {
            return {
                selected: null,
                optionList: [],
                filteredOptionList: [],
                queryText: null,
                isOpenList: false,
                loading: false,
                showCollapse: false
            }
        },
        created: function () {
            this.updateSelectInput();
        },
    methods: {
            changeShowCollapse() {
                if(this.readonly === false)
                {
                    this.showCollapse = !this.showCollapse;
                }
            },
            hide() {
                this.showCollapse = false;
            },
            updateSelectInput() {
                let self = this;
                self.selected = self.value;

                if (self.options.apiCallback) { //ha van api hívás megadva akkor azt használja
                    self.loading = true;
                    self.loading = true;

                    let apiResponse = null;
                    if(self.additionalApiCallbackParams) {
                        apiResponse = self.options.apiCallback({params: self.additionalApiCallbackParams});
                    }
                    else if(self.options.additionalApiCallbackParams){
                        apiResponse = self.options.apiCallback({params: self.options.additionalApiCallbackParams});
                    }
                    else {
                        apiResponse = self.options.apiCallback();
                    }

                    apiResponse
                        .then((response) => {
                            self.optionList = response.data;
                            self.optionsFiltering();
                            self.loading = false;
                        }).catch((err) => {
                        console.error(err);
                        self.loading = false;
                    });
                } else {
                    this.optionList = this.externalOptionList; // ha nincs api ahonnan a lehetőségeket kérje, akkor külső listát használ
                    this.optionsFiltering();
                }
            },

            optionsFiltering() {
                let self = this;

                if (!self.options.minimumInputLength) {
                    if (this.options.searchOnServer) {
                        self.searchOnServer();
                    } else {
                        self.searchOnLocale();
                    }
                } else {
                    if (self.queryText && self.queryText.length >= self.options.minimumInputLength) {
                        if (this.options.searchOnServer) {
                            self.searchOnServer();
                        } else {
                            self.searchOnLocale();
                        }
                    } else {
                        self.filteredOptionList = [];
                    }
                }

            },

            clearOptionList() {
                this.optionList = [];
                this.filteredOptionList = [];
            },

            checkAll() {
                this.selected = this.optionList;
            },

            uncheckAll() {
                this.selected = [];
            },

            checkSpecific(value) {
                this.selected = value;
            },

            searchOnServer() {
                let self = this;
                self.loading = true;
                this.options.apiCallback({
                    params: {
                        ...self.additionalApiCallbackParams,
                        term: self.queryText,
                        type: 'query'
                    }
                }).then((response) => {
                    self.filteredOptionList = response.data;
                    self.loading = false;
                }).catch((err) => {
                    console.error(err);
                    self.loading = false;
                });
            },

            searchOnLocale() {
                let self = this;
                self.filteredOptionList = self.optionList.filter(value => {
                    if (self.options.filteredAttr && self.queryText) {
                        return value[self.options.filteredAttr].toLowerCase().includes(self.queryText.toLowerCase())
                    }
                    return true;
                });
            },
        },
        watch: {
            showCollapse: function (val) {
                if (val) {
                    window.setTimeout(() => {
                        this.$refs['search'].focus();
                    }, 0)
                }
            },
            selected: function (val) {
                this.selected = val;
                this.$emit('input', val);
            },

            queryText: function () {
                this.optionsFiltering();
            },

            additionalApiCallbackParams: {
                handler: function () {
                    this.updateSelectInput();
                },
                deep: true
            },
            options: {
                deep: true,
                immediate: true,
                handler() {
                    this.updateSelectInput();
                }
            }

        }
    }
</script>

<style scoped>
    .checkboxes {
        border: 1px solid;
        border-color: #ced4da;
        border-radius: 0.2rem;
        position: relative;
    }
    .checkboxes.read-only {
        background-color: #e9ecef;
    }

    .checkboxes.show {
        border-radius: 0.2rem 0.2rem 0 0;
    }

    .checkboxes .selected-labels{
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .checkboxes .collapse-toggle {
        background: var(--default-color);
        border: none;
    }

    .checkboxes .collapse-toggle i {
        transform: rotate(0deg);
        -webkit-transition: transform 0.5s;
        transition: transform 0.5s;
    }

    .checkboxes .collapse-toggle.collapsed i {
        transform: rotate(180deg);
    }

    .checkbox-list {
        position: absolute;
        background-color: white;
        border: 1px solid;
        border-color: #ced4da;
        border-top: none;
        border-radius: 0 0 0.2rem 0.2rem;
        left: -1px;
        width: calc(100% + 2px);
        z-index: 5;
        transition: 0.03s;
    }

    .checkboxes ul {
        list-style: none;
        padding-left: 0;
    }

    .checkboxes .select-search {
        border: 1px solid #ced4da;
        border-radius: 0.2rem;
        width: 100%;
        padding: 4px;
        outline-offset: -2px;
        -webkit-appearance: none;
    }

    .checkboxes ul >>> .custom-control-input:checked ~ .custom-control-label::before {
        border-color: var(--default-color);
        background-color: var(--default-color);
    }

    .checkboxes .option-wrapper {
        overflow-y: auto;
        max-height: 200px;
    }

    /*Loader*/

    .lds-ellipsis {
        display: block;
        position: relative;
        width: 64px;
        height: 35px;
        margin: auto;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 12px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: var(--default-color);
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }

    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }
</style>
